import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "menus-card trezo-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "trezo-card-header d-sm-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "trezo-card-title" }
const _hoisted_4 = { class: "search-box position-relative" }
const _hoisted_5 = { class: "trezo-card-subtitle" }
const _hoisted_6 = { class: "trezo-card-content" }
const _hoisted_7 = { class: "basic-table table-responsive" }
const _hoisted_8 = { class: "table mb-0" }
const _hoisted_9 = { scope: "col" }
const _hoisted_10 = { class: "form-check mb-0" }
const _hoisted_11 = ["checked"]
const _hoisted_12 = { class: "form-check mb-0" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "fw-semibold text-body" }
const _hoisted_15 = { class: "employee-info d-flex align-items-center" }
const _hoisted_16 = { class: "img" }
const _hoisted_17 = ["alt", "src"]
const _hoisted_18 = { class: "fw-semibold text-body" }
const _hoisted_19 = { class: "fw-semibold text-body" }
const _hoisted_20 = { class: "action-buttons d-flex justify-content-end align-items-center" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap pt-3" }
const _hoisted_25 = { class: "fs-12 fw-medium" }
const _hoisted_26 = { "aria-label": "Page navigation example" }
const _hoisted_27 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_28 = { class: "page-item" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "page-item" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "popup-dialog" }
const _hoisted_34 = { class: "trezo-card w-100 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_35 = { class: "trezo-card-header d-flex align-items-center justify-content-between" }
const _hoisted_36 = { class: "trezo-card-subtitle" }
const _hoisted_37 = { class: "trezo-card-content" }
const _hoisted_38 = { class: "btn-box" }
const _hoisted_39 = { class: "popup-dialog" }
const _hoisted_40 = { class: "trezo-card w-100 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_41 = { class: "trezo-card-header d-flex align-items-center justify-content-between" }
const _hoisted_42 = { class: "trezo-card-subtitle" }
const _hoisted_43 = { class: "trezo-card-content" }
const _hoisted_44 = { class: "btn-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", _hoisted_4, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { class: "text-black" }, [
              _createElementVNode("i", { class: "material-symbols-outlined" }, " search ")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input-search d-block w-100 border-radius",
              placeholder: "Search here.....",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterMenus && _ctx.filterMenus(...args)))
            }, null, 544), [
              [_vModelText, _ctx.searchQuery]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "add-btn d-inline-block transition fw-medium border-radius",
            type: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleAddPopup && _ctx.toggleAddPopup(...args)))
          }, [...(_cache[13] || (_cache[13] = [
            _createElementVNode("span", { class: "d-inline-block position-relative" }, [
              _createElementVNode("i", { class: "material-symbols-outlined" }, " add "),
              _createTextVNode(" Add New Dish ")
            ], -1)
          ]))])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleAllCheckboxes && _ctx.toggleAllCheckboxes(...args))),
                      checked: _ctx.allItemsSelected
                    }, null, 40, _hoisted_11)
                  ])
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Code", -1)),
                _cache[15] || (_cache[15] = _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Item", -1)),
                _cache[16] || (_cache[16] = _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Price", -1)),
                _cache[17] || (_cache[17] = _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Ingredients", -1)),
                _cache[18] || (_cache[18] = _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Action", -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedMenus, (menu) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: menu.id
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedItems) = $event)),
                        value: menu.id
                      }, null, 8, _hoisted_13), [
                        [_vModelCheckbox, _ctx.selectedItems]
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(menu.code), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("img", {
                          alt: menu.name,
                          src: menu.image
                        }, null, 8, _hoisted_17)
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_RouterLink, {
                          to: "/restaurant/dish-details",
                          class: "d-block fw-semibold"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(menu.name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.formatPrice(menu.price)), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(menu.ingredients), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_RouterLink, {
                        to: "/restaurant/dish-details",
                        class: "p-0 bg-transparent d-inline-block lh-1 border-0"
                      }, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createElementVNode("i", { class: "material-symbols-outlined" }, " visibility ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("button", {
                        type: "button",
                        class: "p-0 bg-transparent d-inline-block lh-1 border-0",
                        onClick: ($event: any) => (_ctx.editMenu(menu))
                      }, [...(_cache[20] || (_cache[20] = [
                        _createElementVNode("i", { class: "material-symbols-outlined" }, " edit ", -1)
                      ]))], 8, _hoisted_21),
                      _createElementVNode("button", {
                        type: "button",
                        class: "p-0 bg-transparent d-inline-block lh-1 border-0",
                        onClick: ($event: any) => (_ctx.deleteMenu(menu.id))
                      }, [...(_cache[21] || (_cache[21] = [
                        _createElementVNode("i", { class: "material-symbols-outlined" }, " delete ", -1)
                      ]))], 8, _hoisted_22)
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.filteredMenus.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [...(_cache[22] || (_cache[22] = [
                    _createElementVNode("td", {
                      colspan: "6",
                      class: "text-center py-4"
                    }, " No menu items found matching your search. ", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("span", _hoisted_25, " Showing " + _toDisplayString(_ctx.startIndex + 1) + " to " + _toDisplayString(_ctx.endIndex) + " of " + _toDisplayString(_ctx.filteredMenus.length) + " Results ", 1),
          _createElementVNode("nav", _hoisted_26, [
            _createElementVNode("ul", _hoisted_27, [
              _createElementVNode("li", _hoisted_28, [
                _createElementVNode("button", {
                  class: "page-link icon",
                  "aria-label": "Previous",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                  disabled: _ctx.currentPage === 1
                }, [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))], 8, _hoisted_29)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "page-item",
                  key: page
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["page-link", { active: page === _ctx.currentPage }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_30)
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_31, [
                _createElementVNode("button", {
                  class: "page-link icon",
                  "aria-label": "Next",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                  disabled: _ctx.currentPage === _ctx.totalPages
                }, [...(_cache[24] || (_cache[24] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))], 8, _hoisted_32)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["add-new-popup", { active: _ctx.showAddPopup }])
    }, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "trezo-card-title" }, [
              _createElementVNode("h5", { class: "mb-0" }, "Add New Dish")
            ], -1)),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleAddPopup && _ctx.toggleAddPopup(...args))),
                class: "p-0 border-0 lh-1 bg-transparent transition"
              }, [...(_cache[25] || (_cache[25] = [
                _createElementVNode("i", { class: "ri-close-fill" }, null, -1)
              ]))])
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _cache[28] || (_cache[28] = _createStaticVNode("<div class=\"row\" data-v-1339e878><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Dish Code </label><input type=\"text\" class=\"form-control\" placeholder=\"E.g. #3215\" data-v-1339e878></div></div><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Name </label><input type=\"text\" class=\"form-control\" placeholder=\"E.g. Parsley Chicken\" data-v-1339e878></div></div><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Price </label><input type=\"text\" class=\"form-control\" placeholder=\"E.g. $12.50\" data-v-1339e878></div></div><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Calorie </label><input type=\"text\" class=\"form-control\" placeholder=\"E.g. 3215 Kcal\" data-v-1339e878></div></div><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Carbs </label><input type=\"text\" class=\"form-control\" placeholder=\"E.g. 525 gm\" data-v-1339e878></div></div><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Protein </label><input type=\"text\" class=\"form-control\" placeholder=\"E.g. 125 gm\" data-v-1339e878></div></div><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Fibres </label><input type=\"text\" class=\"form-control\" placeholder=\"E.g. 15 gm\" data-v-1339e878></div></div><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Fat </label><input type=\"text\" class=\"form-control\" placeholder=\"E.g. 25 gm\" data-v-1339e878></div></div><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Vitamins </label><input type=\"text\" class=\"form-control\" placeholder=\"E.g. 13 gm\" data-v-1339e878></div></div><div class=\"col-md-6\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Sugar </label><input type=\"text\" class=\"form-control\" placeholder=\"E.g. 214 gm\" data-v-1339e878></div></div><div class=\"col-md-6\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Minerals </label><input type=\"text\" class=\"form-control\" placeholder=\"E.g. 5 gm\" data-v-1339e878></div></div><div class=\"col-md-6\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Ingredients Details </label><input type=\"text\" class=\"form-control\" placeholder=\"E.g. Parsley, chicken, mozzarella, buffalo sauce\" data-v-1339e878></div></div><div class=\"col-md-6\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Order In Queue </label><input type=\"text\" class=\"form-control\" placeholder=\"E.g. 17\" data-v-1339e878></div></div><div class=\"col-md-12\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Upload Item Images </label><div class=\"form-control h-100 text-center position-relative p-4 p-lg-5\" data-v-1339e878><div class=\"product-upload\" data-v-1339e878><label for=\"file-upload\" class=\"file-upload mb-0\" data-v-1339e878><i class=\"ri-folder-image-line bg-primary bg-opacity-10 p-2 rounded-1 text-primary\" data-v-1339e878></i><span class=\"d-block text-body fs-14\" data-v-1339e878> Drag and drop an image or <span class=\"text-primary text-decoration-underline\" data-v-1339e878> Browse </span></span></label><input id=\"file-upload\" type=\"file\" data-v-1339e878></div></div></div></div></div>", 1)),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleAddPopup && _ctx.toggleAddPopup(...args))),
                class: "warn d-inline-block fw-medium border-0 border-radius transition"
              }, " Cancel "),
              _cache[27] || (_cache[27] = _createElementVNode("button", { class: "primary d-inline-block fw-medium border-0 border-radius transition" }, [
                _createElementVNode("span", { class: "position-relative d-inline-block" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, " add "),
                  _createTextVNode(" Add Dish ")
                ])
              ], -1))
            ])
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["add-new-popup", { active: _ctx.showEditPopup }])
    }, [
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "trezo-card-title" }, [
              _createElementVNode("h5", { class: "mb-0" }, "Edit Dish")
            ], -1)),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("button", {
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toggleEditPopup && _ctx.toggleEditPopup(...args))),
                class: "p-0 border-0 lh-1 bg-transparent transition"
              }, [...(_cache[29] || (_cache[29] = [
                _createElementVNode("i", { class: "ri-close-fill" }, null, -1)
              ]))])
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _cache[32] || (_cache[32] = _createStaticVNode("<div class=\"row\" data-v-1339e878><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Dish Code </label><input type=\"text\" class=\"form-control\" value=\"#3215\" data-v-1339e878></div></div><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Name </label><input type=\"text\" class=\"form-control\" value=\"Parsley Chicken\" data-v-1339e878></div></div><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Price </label><input type=\"text\" class=\"form-control\" value=\"$12.50\" data-v-1339e878></div></div><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Calorie </label><input type=\"text\" class=\"form-control\" value=\"3215 Kcal\" data-v-1339e878></div></div><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Carbs </label><input type=\"text\" class=\"form-control\" value=\"525 gm\" data-v-1339e878></div></div><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Protein </label><input type=\"text\" class=\"form-control\" value=\"125 gm\" data-v-1339e878></div></div><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Fibres </label><input type=\"text\" class=\"form-control\" value=\"15 gm\" data-v-1339e878></div></div><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Fat </label><input type=\"text\" class=\"form-control\" value=\"25 gm\" data-v-1339e878></div></div><div class=\"col-md-4\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Vitamins </label><input type=\"text\" class=\"form-control\" value=\"13 gm\" data-v-1339e878></div></div><div class=\"col-md-6\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Sugar </label><input type=\"text\" class=\"form-control\" value=\"214 gm\" data-v-1339e878></div></div><div class=\"col-md-6\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Minerals </label><input type=\"text\" class=\"form-control\" value=\"5 gm\" data-v-1339e878></div></div><div class=\"col-md-6\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Ingredients Details </label><input type=\"text\" class=\"form-control\" value=\"Parsley, chicken, mozzarella, buffalo sauce\" data-v-1339e878></div></div><div class=\"col-md-6\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Order In Queue </label><input type=\"text\" class=\"form-control\" value=\"17\" data-v-1339e878></div></div><div class=\"col-md-12\" data-v-1339e878><div class=\"form-group\" data-v-1339e878><label class=\"main-label d-block fw-medium text-black\" data-v-1339e878> Upload Item Images </label><div class=\"form-control h-100 text-center position-relative p-4 p-lg-5\" data-v-1339e878><div class=\"product-upload\" data-v-1339e878><label for=\"file-upload\" class=\"file-upload mb-0\" data-v-1339e878><i class=\"ri-folder-image-line bg-primary bg-opacity-10 p-2 rounded-1 text-primary\" data-v-1339e878></i><span class=\"d-block text-body fs-14\" data-v-1339e878> Drag and drop an image or <span class=\"text-primary text-decoration-underline\" data-v-1339e878> Browse </span></span></label><input id=\"file-upload\" type=\"file\" data-v-1339e878></div></div></div></div></div>", 1)),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("button", {
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleEditPopup && _ctx.toggleEditPopup(...args))),
                class: "warn d-inline-block fw-medium border-0 border-radius transition"
              }, " Cancel "),
              _createElementVNode("button", {
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.updateMenuItem && _ctx.updateMenuItem(...args))),
                class: "primary d-inline-block fw-medium border-0 border-radius transition"
              }, [...(_cache[31] || (_cache[31] = [
                _createElementVNode("span", { class: "position-relative d-inline-block" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, " add "),
                  _createTextVNode(" Save ")
                ], -1)
              ]))])
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}